export default class SmoothScroll {
  constructor() {
    this.$targets = [...document.querySelectorAll('a[href^="#"]')]
    this.$disable = document.querySelector('[data-disable-page-top]');
    if(!this.$targets || this.$disable) return;
    this.$pageTop = document.querySelector('[data-page-top]');
    this.init();
  }

  init() {
    this.onClick();
  }

  onClick() {
    this.$targets.forEach(target => {
      target.addEventListener('click', (e) => {
        const href = e.currentTarget.getAttribute('href')
        e.preventDefault()
        e.stopImmediatePropagation()
        if (!window.pageYOffset > 0) {
          this.$pageTop.style.position = 'absolute';
        }
        if(href != null) {
          setTimeout(() => {
            this.$pageTop.style.position = 'fixed';
            gsap.to(window, {
              duration: 1,
              scrollTo: href === '#' ? 0 : href,
              ease: 'power2.out',
            })
          }, 100);
        }
      })
    });
  }
}
